import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import { useGet } from "../libs/service/api";
import Card from '../components/Card'
import PlanningZoning from '../assets/svg/planning-zoning.svg'
import PublicWorks from '../assets/svg/public-works.svg'
import GisIT from '../assets/svg/gis-it.svg'
import BG from '../assets/mountain-bg.png'
import Button from '../components/Button'
import Header from '../components/Header'
import Alert from '../components/Alert'
import Loader from "../components/loader";
// import commonService from '../services/commonService';
import cookie from "../libs/cookie/client";
const AreaOfInterest = props => {
    const history = useHistory();
    const [activeProfession, setActiveProfession] = useState(false)
    const [activeid, setActiveID] = useState(0)
    const [userid2, setUserid2] = useState(cookie.getItem('userid'))
    const [isError, setIsError] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [editAssesmentid, seteditAssesmentid] = useState();

    const listOfProfession = [
        {
            image: PlanningZoning,
            title: "Planning & Zoning",
            id: 1
        },
        {
            image: PublicWorks,
            title: "Public Works",
            id: 2
        },
        {
            image: GisIT,
            title: "GIS - IT",
            id: 3
        }
    ]

    const backPress = () => {
        if (cookie.getItem('authorizationKey') !== null && cookie.getItem('email') !== null) {
            history.goBack();
        } else {
            cookie.removeItem('userid');
            localStorage.removeItem("userid");
            cookie.removeItem('needsassesmentid');
            localStorage.removeItem("needsassesmentid");
            history.goBack();
        }
    }

    const goToQuestionnaire = () => {
        if (activeid > 0) {
            setIsError(false)
            let activeLink = null;
            switch (activeProfession) {
                case "Planning & Zoning":
                    activeLink = "city-planning/1"
                    break
                case "Public Works":
                    activeLink = "public-works/1"
                    break
                default:
                    activeLink = "gis-it/1"
                    break
            }
            GetNeedsassesmentid(activeLink, activeid)
            setIsLoading(true)
        } else {
            setIsError(true)
        }
    }

    const GetNeedsassesmentid = (activeLink, activeid) => {
        var useridtemp;
        if (userid2 === null) {
            useridtemp = 0;
        } else {
            useridtemp = userid2;
        }
        return useGet("/commonapi/newstartnewjourney?personaid=" + activeid + "&userid=" + useridtemp + "&needsassesmentid=" + editAssesmentid).then(res => {
            // console.log('area of interest');
            // console.log(res.Data.Table);
            // console.log(res.Data.Table[0].needsassesmentid);
            if (res && !res.ErrorState) {
                cookie.setItem('needsassesmentid', res.Data.Table[0].needsassesmentid);
                // if (editAssesmentid == null) {
                //     cookie.setItem('needsassesmentid', res.Data.Table[0].needsassesmentid);
                // } else {
                //     cookie.setItem('needsassesmentid', editAssesmentid);
                // }
                switch (activeProfession) {
                    case "Planning & Zoning":
                        cookie.setItem('areaofinterest', "PLANNING & ZONING");
                        break
                    case "Public Works":
                        cookie.setItem('areaofinterest', "PUBLIC WORKS");
                        break
                    default:
                        cookie.setItem('areaofinterest', "GIS-IT");
                        break
                }
                history.push(`/questionnaire/${activeLink}/${activeid}`);
            } else {
                console.log('Error');
            }
            // console.log("after load");
            // console.log(cookie.getItem('needsassesmentid'))
        });
    }

    useEffect(() => {
        const location = window.location.hash.split('/').slice(-1).toString();
        seteditAssesmentid(location);
        setUserid2(cookie.getItem('userid'))
    }, []);


    return (
        <div style={{ backgroundImage: `url(${BG})` }} className="bg-bottom bg-cover bg-no-repeat min-h-screen flex flex-col items-center relative z-10">
            <Header rightContent={
                <div className="text-secondary font-semibold pl-6 border-l border-secondary">
                    {"AREA OF INTEREST"}
                </div>
            } />

            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <h2 className="text-center font-bold text-2xl mb-3 2xl:mb-16  pt-20 2xl:pt-39">Select your <span className="text-secondary">Area of Interest</span></h2>
                    {isError && <Alert type="secondary" heading="Area Of Interest" content="Select area of interest" isVisible={true} />}

                    <div className="flex justify-center">
                        {listOfProfession.map(profession => <Card onClick={() => {
                            setActiveProfession(profession.title)
                            setActiveID(profession.id)
                        }} key={profession.title}
                            minHeight={228}
                            image={profession.image} title={profession.title} active={activeProfession === profession.title} />)}
                    </div>

                    <div className="flex justify-center mt-20">
                        <Button btnStyle="secondary-outline" text="Back" onClick={() => { backPress() }} />
                        <Button onClick={() => { goToQuestionnaire() }} btnStyle="secondary" text="Next" extraClasses="ml-3" />
                    </div>
                </>
            }
        </div>
    )
}



export default AreaOfInterest
